import React, {Component} from 'react'
import TableComp from '../../../../components/_utils/table'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import {RightsWrapper} from '../../../../components/_utils/utils'

import { Link } from "react-router-dom";

import moment from 'moment'
import {Button, Card, Col, notification, Popconfirm, Row, Select, Table, Tabs, Tooltip} from 'antd'
import Request from '../../../../request'

import {connect} from 'react-redux'
import styles from '../../country/all/styles.less'
import {getUrlPushWrapper} from '../../../../routes'
import {hideLoader, showLoader} from '../../../../modules/actions'
import commonStyle from '../../../common.less'

const TabPane = Tabs.TabPane
const Option = Select.Option
let facId = null

class AllFaculty extends Component {
    state = {count: 0, arr: [], list: [], localUser:{}}

    constructor(props) {
        super(props)

        this.table = React.createRef()

        this.loadFaculties()
        this.loadSimpleFaculties()
    }

    componentDidMount() {
        facId = null
        let localUser = JSON.parse(localStorage.getItem('user'))
        this.setState({localUser})
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            // params.count = 200
            params.sortField = 'facultyName'
            params.sortOrder = 'ascend'
            let data = await Request.loadFaculties({
                ...params,
                regExFilters: ['facultyName']
            })
            this.setState({count: data.total})
            resolve(data)
        })
    }
    loadFaculties = () => {
        let params = {}
        return new Promise(async resolve => {
            // params.count = 200
            params.sortField = 'facultyName'
            params.sortOrder = 'ascend'
            let data = await Request.loadFaculties({...params})

            resolve(data)
        })
    }
    loadSimpleFaculties = () => {
        let params = {}
        return new Promise(async resolve => {
            // params.count = 200
            params.sortField = 'facultyName'
            params.sortOrder = 'ascend'
            let data = await Request.loadSimpleFaculties({...params})
            this.setState({arr: data.data})
            console.table(data)
            resolve(data)
        })
    }
    handleChange = async v => {
        facId = v
    }

    searchbtn = async () => {
        const {dispatch} = this.props

        dispatch(showLoader())

        this.setState({list: []})

        let data = await Request.facultyWiseCourse(facId)

        this.setState({list: data.data})

        dispatch(hideLoader())
    }

    handleDelete = (facultyId) => {
        Request.deleteFaculty({_id: facultyId})
            .then(x => {

                if (x.success) {
                    notification.success({
                        message: x.msg,
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.table.current.reload()
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    render() {
        const {dispatch} = this.props

        const columns = [
            {
                title: 'Faculty Name',
                key: 'facultyName',
                dataIndex: 'facultyName',

                searchTextName: 'facultyName',
                filterRegex: true
            },
            {
                title: 'Last Updated By',
                key: 'lastUpdatedByName',
                dataIndex: 'lastUpdatedByName',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>
                                {text} {record.lastUpdate}
                            </div>

                            <small>{moment(record.time).fromNow()}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',

                render: (text, record) => (
                    <React.Fragment>
                        {record.businessId === this.state.localUser.businessId?
                        <RightsWrapper myRight={'Faculty.edit'}>
                            <Tooltip title="Edit Details">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    href={`/master/edit-faculty?id=${record._id}`}
                                    icon="edit"
                                />
                            </Tooltip>

                            <Tooltip title="Delete Faculty">
                                <Popconfirm
                                    title="Are you sure to delete Faculty?"
                                    onConfirm={() => this.handleDelete(record._id)}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        className={styles.btn}
                                        icon="delete"/>
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                        :null}
                    </React.Fragment>

                )
            }
        ]
        const columnCourse = [
            {
                title: 'Course Name',
                key: 'courseName',
                dataIndex: 'courseName',
                render: (val, record) => {
                    return (
                        <a
                            target={'_blank'}
                            onClick={() => {
                                dispatch(
                                    getUrlPushWrapper('masters.editCourse', {
                                        id: record.courseId
                                    })
                                )
                            }}>
                            {record.courseName}
                        </a>
                    )
                }
            },
            {
                title: 'Course University',
                key: 'universityInstitutionName',
                dataIndex: 'universityInstitutionName'
            }
        ]
        return (
            <PageHeaderWrapper title={`Total Faculties : ${this.state.count}`}>
                <Card style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={12}>
                        </Col>
                        <Col span={10}>
                        </Col>
                        <Col span={2}>
                            <div style={{textAlign: 'right', marginTop: '15px'}}>
                                <Link to='/master/add-faculty'><Button>Add</Button></Link>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <Tabs type="card">
                        <TabPane tab={'Faculty List'} key={1}>
                            <TableComp columns={columns}
                                       apiRequest={this.apiRequest}
                                       ref={this.table}/>
                        </TabPane>
                        <TabPane tab={'Faculty Courses'} key={2}>
                            <Card>
                                <Row>
                                    <Col span={4}>Choose Faculty</Col>
                                    <Col span={6}>
                                        <Select
                                            onChange={this.handleChange}
                                            placeholder="Choose Faculty"
                                            showSearch={true}
                                            optionFilterProp="children"
                                            style={{width: 200}}>
                                            {this.state.arr.map((val, index) => {
                                                return (
                                                    <Option key={index} value={val._id}>
                                                        {val.facultyName}
                                                    </Option>
                                                )
                                            })}
                                        </Select>
                                    </Col>
                                    <Col span={4}>
                                        <Button
                                            onClick={() => this.searchbtn()}
                                            loading={this.props.loading}>
                                            Search
                                        </Button>
                                    </Col>
                                </Row>
                            </Card>

                            {this.state.list.length ? (
                                <Card>
                                    <h4>Total Course : {this.state.list.length}</h4>
                                    <Table
                                        bordered={true}
                                        dataSource={this.state.list}
                                        columns={columnCourse}
                                    />
                                </Card>
                            ) : null}
                        </TabPane>
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllFaculty)
